import React, { FC, useEffect } from 'react';
import UserDefaultProfile from '../../../images/UserProfileDefault.svg';
import { getPersonByID } from '../../../services/enrolmentService';
import {useLocale} from "../../../contexts/localeContext";

interface MasterImageProps {
    row: any;
}

const MasterImageProfile: FC<MasterImageProps> = ({ row }) => {
    const [image, setImage] = React.useState<string | null>(null);
    const {credentialHolder, credentialHolderId } = row;
    const {translate} = useLocale();

    const loadImage = async () => {
        if (credentialHolderId && credentialHolderId === "-") return;
        try {
            const person = await getPersonByID(translate, credentialHolderId);
            if (person.masterImages && person.masterImages.length > 0) {
                setImage(
                    `data:image/png;base64,${person.masterImages[0].base64Thumb}`,
                );
            } else {
                setImage(UserDefaultProfile);
            }
        } catch (e) {
            setImage(UserDefaultProfile);
        }
    };

    useEffect(() => {
        loadImage();
    }, [row]);

    return (
        <div className="flex items-center">
            {credentialHolder !== "-" && image  ? (
                <div className="custome-avatar rounded-full overflow-hidden">
                    <img src={image} />
                </div>
            ) :
                credentialHolder !== "-" && <div className="custome-avatar rounded-full overflow-hidden">
                    <img src={UserDefaultProfile} />
                </div>
            }
            <button
                className="text-portal-blue-primary-shade2 hover:text-blue-300 focus:outline-none px-2 py-1 text-xs"
                onClick={() => {
                    // will be used to invoke profile modal
                }}
            >
                {credentialHolder !== "-" && credentialHolder}
            </button>
        </div>
    );
};

export default MasterImageProfile;
